import { convertToCurrency } from '../../d3-services/_helpers';
import { colours } from "../../_styleguide/_colours";
var ChartBar = /** @class */ (function () {
    function ChartBar(ctrlr) {
        this.ctrlr = ctrlr;
    }
    ChartBar.prototype.draw = function (data) {
        this.bars = this.ctrlr.svg.layers.data.selectAll(".bar")
            .data(data)
            .join("rect")
            .attr("class", "bar")
            .attr("fill", function (d) { return colours[d.colour][1]; })
            .attr("stroke", function (d) { return colours[d.colour][0]; });
        this.barLabels = this.ctrlr.svg.layers.data.selectAll(".barLabel")
            .data(data)
            .join('text')
            .attr('class', 'barLabel smallest-label')
            .attr('x', 0)
            .attr('dx', '0px')
            .attr('dy', '-4px')
            .style("text-anchor", "middle");
    };
    ChartBar.prototype.redraw = function (data) {
        var _this = this;
        var self = this;
        this.bars
            .attr("x", function (d) {
            return self.ctrlr.scales.x.fn(d[self.ctrlr.parameters.x]);
        })
            .attr("y", self.ctrlr.dimensions.height)
            .attr("height", 0)
            .attr("width", (self.ctrlr.scales.x.config.type === 'band') ? self.ctrlr.scales.x.scale.bandwidth() : self.ctrlr.dimensions.width / data.length - 1)
            .transition()
            .duration(500)
            .attr("y", function (d) { return (_this.ctrlr.config.extra.privacySensitive && d[self.ctrlr.parameters.y] < 25) ? self.ctrlr.dimensions.height : self.ctrlr.scales.y.fn(d[self.ctrlr.parameters.y]); })
            .attr("height", function (d) { return (_this.ctrlr.config.extra.privacySensitive && d[self.ctrlr.parameters.y] < 25) ? 0 : self.ctrlr.dimensions.height - self.ctrlr.scales.y.fn(d[self.ctrlr.parameters.y]); });
        this.barLabels
            .text(function (d) {
            if (self.ctrlr.firstMapping.format === 'currency') {
                return convertToCurrency(d[self.ctrlr.parameters.y]);
            }
            else if (self.ctrlr.firstMapping.format === 'percentage') {
                return d[self.ctrlr.parameters.y] + "%";
            }
            else {
                return (self.ctrlr.config.extra.privacySensitive && d[self.ctrlr.parameters.y] < 25) ? '< 25' : d[self.ctrlr.parameters.y];
            }
        })
            .attr('transform', function (d) {
            if (_this.ctrlr.scales.x.config.type === "band") {
                return 'translate(' + (self.ctrlr.scales.x.fn(d[self.ctrlr.parameters.x]) + (self.ctrlr.scales.x.scale.bandwidth() / 2)) + ',' +
                    ((self.ctrlr.config.extra.privacySensitive && d[self.ctrlr.parameters.y] < 25) ? self.ctrlr.dimensions.height : self.ctrlr.scales.y.fn(d[self.ctrlr.parameters.y]))
                    + ')';
            }
            else {
                return 'translate(' + (self.ctrlr.dimensions.width / 2) + ',' +
                    ((self.ctrlr.config.extra.privacySensitive && d[self.ctrlr.parameters.y] < 25) ? self.ctrlr.dimensions.height : self.ctrlr.scales.y.fn(d[self.ctrlr.parameters.y]))
                    + ')';
            }
        })
            .attr('fill-opacity', 0)
            .transition()
            .delay(500)
            .duration(500)
            .attr('fill-opacity', 1);
    };
    return ChartBar;
}());
export { ChartBar };
